module.exports = __webpack_public_path__ + "assets/img/icons8-spain-144.f902ce2d.png";